export default "__VITE_PUBLIC_ASSET__b7576fdf__"